import { Dictionary } from '@/composables/advert/advertManager'

const shortcutMap: Dictionary<Dictionary<string>> = {
  ')': {
    ':': '🙂',
    ';': '😉',
    '*': '😘',
  },
  '(': {
    ':': '😕',
    '*': '😥',
  },
  D: {
    ':': '😄',
  },
  P: {
    ':': '😋',
  },
}

export default function useEmojiShortcuts() {
  const replaceEmoji = (
    lastChar: string,
    position: number,
    input: string
  ): string => {
    if (lastChar in shortcutMap) {
      const possibleEmojis: Dictionary<string> = shortcutMap[lastChar]

      if (position > 0) {
        const prevChar = input.slice(position - 1, position)
        if (prevChar in possibleEmojis) {
          return (
            input.slice(0, position - 1) +
            possibleEmojis[prevChar] +
            input.slice(position + 1)
          )
        }
      }

      return input
    }

    return input
  }

  return {
    replaceEmoji,
  }
}
